export const MenuListArray2 = [
    {
        title: 'Home',	
        classsChange: 'sub-menu-down',		
        content: [
            {
                title: 'Home-1',
                to: './',					
            },
            {
                title: 'Home-2',
                to: './index-2',
                
            },
            {
                title: 'Home-3',
                to: './index-3',
                
            },
            {
                title: 'Home-4',
                to: './index-4',
                

            },
            {
                title: 'Home-5',
                to: './index-5',
                
            },
            
        ],
    },
    {
        title: 'Page',
        classsChange: 'has-mega-menu',        
        content: [
            {
                title: 'Pages',
                content:[
                    {
                        title: 'About Me',
                        to: './about-me',
                    },
                    {
                        title: 'About Us',
                        to: './about-us',
                    },
                    {
                        title: 'Coming Soon',
                        to: './coming-soon',
                    },
                    {
                        title: 'Team',
                        to: './team',
                    },
                ],
            },
            {
                title: 'Pages',
                content:[
                
                    {
                        title: 'Company History',
                        to: './company-history',
                    },
                    {
                        title: 'Contact Us',
                        to: './contact-us',
                    },
                    {
                        title: 'Error 404',
                        to: './error-404',
                    },
                ],
            },
            {
                title: 'Pages',
                content:[
               
                    {
                        title: 'Gallery Grid 4',
                        to: './gallery-grid-4',
                    },
                    {
                        title: 'Gallery Masonry',
                        to: './gallery-masonry',
                    },
                    {
                        title: 'Help Desk',
                        to: './help-desk',
                    },
                ],
            },
            {
                title: 'Pages',
                content:[
                    {
                        title: 'Pricing Table',
                        to: './pricing',
                    },
                    {
                        title: 'Privacy Policy',
                        to: './privacy-policy',
                    },
                    {
                        title: 'Services',
                        to: './services',
                    },
                ],
            },    

        ],
    },
    {
        title: 'Portfolio',	
        classsChange: 'sub-menu-down',
        content: [
            {
                title: 'Portfolio 1',
                to: './portfolio',
            },
            {
                title: 'Portfolio Collage',
                to: './portfolio-collage',
            },
            {
                title: 'Portfolio Details',
                to: './portfolio-details',
            },
        ],
    },
    {
        title: 'Shop',
        classsChange: 'sub-menu-down',
        content : [
            {
                title: 'Shop Grid 3',
                to: './shop-grid-3',
            },
            {
                title: 'Product Details',
                to: './product-details',
            },
            {
                title: 'Wishlist',
                to: './shop-wishlist',
            },
            {
                title: 'Checkout',
                to: './shop-checkout',
            },
            {
                title: 'Cart',
                to: './shop-cart',
            },
            {
                title: 'Login',
                to: './login',
            },
        ],
    },
    {
        title: 'Blog',
        classsChange: 'sub-menu-down',
        content:[
            {
                title:'Blog Grid',
                to:'./blog-grid',
            },
            {
                title:'Blog Right Sidebar',
                to:'./blog-large-right-sidebar',
            },
            {
                title:'Blog List Sidebar',
                to:'./blog-list-sidebar',
            },
            {
                title:'Blog List Left Sidebar',
                to:'./blog-list-left-sidebar',
            },
            {
                title:'Post Wide View',
                to:'./blog-details-post-wide',
            },
            {
                title:'Blog Details',
                to:'./blog-details',
            },
        ],
    }
]